/**
 * @generated SignedSource<<b4019ca25174a198d37a738d27d6b664>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrgStoreWorkspaceBreadcrumbsWithoutExternalId_store$data = {
  readonly workspaceBreadcrumbs: ReadonlyArray<string>;
  readonly " $fragmentType": "OrgStoreWorkspaceBreadcrumbsWithoutExternalId_store";
};
export type OrgStoreWorkspaceBreadcrumbsWithoutExternalId_store$key = {
  readonly " $data"?: OrgStoreWorkspaceBreadcrumbsWithoutExternalId_store$data;
  readonly " $fragmentSpreads": FragmentRefs<"OrgStoreWorkspaceBreadcrumbsWithoutExternalId_store">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "currentWorkspaceId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "OrgStoreWorkspaceBreadcrumbsWithoutExternalId_store",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "belowWorkspaceId",
          "variableName": "currentWorkspaceId"
        },
        {
          "kind": "Literal",
          "name": "includeExternalId",
          "value": false
        }
      ],
      "kind": "ScalarField",
      "name": "workspaceBreadcrumbs",
      "storageKey": null
    }
  ],
  "type": "Store",
  "abstractKey": null
};

(node as any).hash = "1c3906c873519c31d3dbd8965b5df659";

export default node;
